import Vue from 'vue'
import Vuex from 'vuex'
import maps from './maps.js'
Vue.use(Vuex)

export const store = new Vuex.Store({
  strict: true,
  state: {
    maps: maps,
    exhibits: {},
    distances: {},
    ordered: [],
    nearest: [],
    exhibit_groups: {},
    filter_data: null,
    filter_stage: 'filterupload',
    filter_selected: 0,
    user_coords: {},
    exhibit_data: {},
    inzone: false,
    exhibitnames: {},
    isnight: false
  },
  mutations: {
    setmessage (state, message) {
      state.message = message
    },
    setexhibits (state, exhibits) {
      state.exhibits = exhibits
    },
    setnearest (state, nearest) {
      state.nearest = nearest
    },
    setordered (state, ordered) {
      state.ordered = ordered
    },
    setdistances (state, distances) {
      state.distances = distances
    },
    setexhibitgroups (state, groups) {
      state.exhibit_groups = groups
    },
    setfilterdata (state, data) {
      state.filter_data = data
    },
    setfilterview (state, view) {
      state.filter_stage = view
    },
    setfilterselected (state, sel) {
      state.filter_selected = sel
    },
    setuserposition (state, pos) {
      state.user_coords = pos
    },
    setexhibitdata (state, data) {
      state.exhibit_data = data
    },
    inzone (state, inzone) {
      state.inzone = inzone
    },
    exhibitnames (state, names) {
      state.exhibitnames = names
    },
    isnight (state, isnight) {
      state.isnight = isnight
    }
  },
  getters: {
    message (state) {
      return state.message
    },
    map_settings (state) {
      return state.map_settings
    },
    user_position (state) {
      return state.user_coords
    }
  }
})
